import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { RESET_PASSWORD } from "./actionTypes"
import { userResetPasswordSuccess, userResetPasswordError } from "./actions"

//Include Both Helper File with needed methods
import { resetPwd } from "../../../helpers/backend_helper"

// const fireBaseBackend = getFirebaseBackend()
import toast from "react-hot-toast";

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* resetUser({ payload: { users, history } }) {
  try{
    const response = yield call(resetPwd,{
      email: users.email,
      pwd:users.pwd,
      confPwd:users.confPwd,
      verificationToken:users.verificationToken
    }) 
    if(response.status === "success") {
      toast.success(response.message);
      yield put(userResetPasswordSuccess(response.message));
      history.push("/login");
    }else {
      toast.error(response.message);
      yield put(userResetPasswordError(response.message));
    }
  } catch(error){  
    toast.error(error.response.data.message,{duration: 6000})
    yield put(userResetPasswordError(error.response.data.message));
  }

}

export function* watchUserPasswordReset() {
  yield takeEvery(RESET_PASSWORD, resetUser)
}

function* ResetPasswordSaga() {
  yield all([fork(watchUserPasswordReset)])
}

export default ResetPasswordSaga
